import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "Kapadokya'ya gitmek için en iyi zaman hangisi?",
    a: "Kapadokya'yı ziyaret etmek için en ideal dönemler Nisan–Haziran ve Eylül–Kasım aylarıdır. Bu dönemlerde hava ılıman, balon turları düzenli yapılır ve vadiler çiçek açar. Kış aylarında (Aralık–Şubat) karla kaplı peri bacaları eşsiz bir manzara sunar; ancak balon turları hava koşullarına bağlı olarak iptal edilebilir.",
  },
  {
    q: "Kapadokya'da balon turu nasıl yapılır ve ne kadar sürer?",
    a: "Balon turları şafaktan yaklaşık 1 saat önce başlar ve 1–1,5 saat sürer. Göreme'deki lisanslı balon şirketleri aracılığıyla rezervasyon yapabilirsiniz. Fiyatlar kişi başı 150–250 Euro arasında değişmektedir. Rüzgar ve hava koşulları nedeniyle iptal olabilir; bu durumda tam iade yapılır. En az 2–3 gün öncesinden rezervasyon yaptırmanızı öneririz.",
  },
  {
    q: "Kapadokya'da kaç gün geçirmek gerekir?",
    a: "Kapadokya'yı yeterince görmek için en az 3 gün gerekir. İlk gün Göreme Açık Hava Müzesi ve Güvercinlik Vadisi, ikinci gün balon turu ve Derinkuyu/Kaymaklı yeraltı şehirleri, üçüncü gün ise Ihlara Vadisi ve Selime Katedrali için idealdir. Daha kapsamlı bir ziyaret için 4–5 gün ayırabilirsiniz.",
  },
  {
    q: "Kapadokya'da kaya otel deneyimi nasıl?",
    a: "Kaya oyma oteller Kapadokya'nın en özgün konaklama seçenekleridir. Göreme, Ürgüp ve Uçhisar'da çok sayıda butik kaya otel bulunmaktadır. Odalar genellikle doğal kaya içine oyulmuş, modern konforla donatılmıştır. Sabah kahvaltısı terasta, balon turlarının eşliğinde servis edilir. Fiyatlar sezona ve otele göre 1.500–8.000 TL arasında değişmektedir.",
  },
  {
    q: "Kapadokya'da mutlaka görülmesi gereken yerler hangileri?",
    a: "Göreme Açık Hava Müzesi, Derinkuyu Yeraltı Şehri, Ihlara Vadisi, Güvercinlik Vadisi, Kızılçukur Vadisi, Uçhisar Kalesi, Paşabağ (Mantar Kayalar) ve Avanos çömlek atölyeleri Kapadokya'nın mutlaka görülmesi gereken yerleri arasındadır.",
  },
  {
    q: "Kapadokya'ya nasıl gidilir?",
    a: "Kapadokya'ya ulaşmak için en pratik yol Nevşehir veya Kayseri havalimanlarına uçmaktır. Her iki havalimanından da Göreme'ye servis araçları mevcuttur. İstanbul'dan otobüsle yaklaşık 10–12 saat sürer; gece otobüsleri tercih edilebilir. Kayseri'den Göreme'ye yaklaşık 1,5 saat, Nevşehir'den ise 45 dakika sürer.",
  },
  {
    q: "Kapadokya'da ATV ve at turu yapılabilir mi?",
    a: "Evet, Kapadokya'da ATV (dört tekerlekli araç) ve at turları oldukça popülerdir. Göreme çevresindeki vadilerde düzenlenen bu turlar genellikle 1–2 saat sürer. Gün batımında yapılan ATV turları özellikle tavsiye edilir; kırmızıya boyanan peri bacaları arasında sürmek unutulmaz bir deneyimdir.",
  },
  {
    q: "Kapadokya'da şarap tadımı yapılabilir mi?",
    a: "Kapadokya, Türkiye'nin en önemli şarap üretim bölgelerinden biridir. Ürgüp ve Avanos çevresindeki bağlarda yetiştirilen Öküzgözü ve Boğazkere üzümlerinden üretilen şaraplar dünyaca tanınmaktadır. Bölgedeki şarap mahzenleri ve butik bağ evleri tadım turları düzenlemektedir; özellikle Kocabağ ve Turasan şarap fabrikaları ziyaret edilebilir.",
  },
  {
    q: "Kapadokya'da çocuklarla gidilir mi?",
    a: "Kapadokya çocuklar için de harika bir destinasyondur. Yeraltı şehirleri, ATV turları ve at binme aktiviteleri çocukların çok sevdiği deneyimler arasındadır. Balon turları genellikle 6 yaş ve üzeri çocuklar için uygundur; ancak şirketlere göre yaş sınırı değişebilir. Vadilerdeki yürüyüş parkurları da aileler için idealdir.",
  },
  {
    q: "Kapadokya'da fotoğraf çekmek için en iyi noktalar nereler?",
    a: "Göreme Panorama Noktası (balon turları için), Kızılçukur Vadisi (gün batımı), Güvercinlik Vadisi (sabah ışığı), Uçhisar Kalesi (panoramik manzara) ve Paşabağ (mantar kayalar) Kapadokya'nın en iyi fotoğraf noktaları arasındadır. Şafak ve gün batımı saatleri en dramatik ışığı sunar.",
  },
  {
    q: "Kapadokya'da ne yenilmeli?",
    a: "Kapadokya'da mutlaka tatmanız gereken lezzetler: testi kebabı (kil tencerede pişirilir), mantı (Kayseri usulü), Kapadokya şarapları, taze yaprak sarma, Avanos'ta çömlek usulü pişirilmiş yemekler ve bölgeye özgü pekmez tatlılarıdır. Göreme'deki yerel restoranlar bu lezzetleri en otantik haliyle sunar.",
  },
  {
    q: "Kapadokya'da hangi vadiler yürüyüş için uygundur?",
    a: "Ihlara Vadisi (14 km, orta zorluk), Güvercinlik Vadisi (kolay, 3 km), Kızılçukur Vadisi (kolay, 2 km), Zemi Vadisi (orta, 4 km) ve Bağlıdere Vadisi (kolay, 3 km) Kapadokya'nın en popüler yürüyüş rotaları arasındadır. Tüm vadiler için rahat yürüyüş ayakkabısı ve su taşımanızı öneririz.",
  },
];

const KapadokyaFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const title = "Kapadokya Seyahat SSS — Balon Turu, Kaya Otel ve Gezilecek Yerler 2026";
    const desc = "Kapadokya'ya seyahat planlayanlar için en sık sorulan sorular: balon turu, kaya otel, gezilecek yerler, ulaşım ve en iyi zaman hakkında kapsamlı rehber.";
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
      el.textContent = JSON.stringify(data);
    };

    setCanonical("https://geziturkiyem.com/kapadokya-sss");
    setMeta("description", desc);
    setMeta("keywords", "kapadokya seyahat, kapadokya balon turu, kapadokya kaya otel, kapadokya sss, kapadokya rehberi, kapadokya peri bacalari, kapadokya goreme, kapadokya urgup, kapadokya avanos, kapadokya uchisar, kapadokya derinkuyu yeralti sehri, kapadokya kaymaklı yeralti sehri, kapadokya ihlara vadisi, kapadokya guvercinlik vadisi, kapadokya kizilcukur vadisi, kapadokya pasabag mantar kayalar, kapadokya selime katedrali, kapadokya atv turu, kapadokya at turu, kapadokya sarap tadimi, kapadokya ne zaman gidilir, kapadokya konaklama, kapadokya ulasim, kapadokya nevsehir, kapadokya kayseri, kapadokya goreme acik hava muzesi, kapadokya fotograf noktalari, kapadokya cocuklar, kapadokya yuruyus, kapadokya testi kebabi, kapadokya manti, kapadokya sarap, nevsehir gezilecek yerler, kayseri gezilecek yerler, turkiye balon turu, kapadokya ucuz balon turu");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "article", true);
    setMeta("og:url", "https://geziturkiyem.com/kapadokya-sss", true);
    setMeta("og:image", "https://readdy.ai/api/search-image?query=Cappadocia%20Turkey%20hot%20air%20balloons%20sunrise%20fairy%20chimneys%20golden%20light%20dramatic%20landscape&width=1200&height=630&seq=kap-sss-og&orientation=landscape", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);

    injectSchema("schema-kapadokya-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });

    injectSchema("schema-kapadokya-breadcrumb", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" },
        { "@type": "ListItem", "position": 2, "name": "Kapadokya SSS", "item": "https://geziturkiyem.com/kapadokya-sss" },
      ],
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
      const s1 = document.getElementById("schema-kapadokya-faq");
      const s2 = document.getElementById("schema-kapadokya-breadcrumb");
      if (s1) s1.remove();
      if (s2) s2.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 pb-16 overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Cappadocia%20Turkey%20dozens%20of%20colorful%20hot%20air%20balloons%20floating%20above%20fairy%20chimneys%20at%20golden%20sunrise%20magical%20sky%20wide%20panoramic&width=1400&height=500&seq=kap-sss-hero&orientation=landscape"
            alt="Kapadokya"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-stone-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Kapadokya SSS</span>
          </nav>
          <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            Sık Sorulan Sorular
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Kapadokya Seyahat Rehberi
          </h1>
          <p className="text-stone-300 text-sm max-w-xl mx-auto">
            Kapadokya'ya seyahat planlayanların en çok merak ettiği sorular ve kapsamlı cevapları.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-14">
        {/* Intro */}
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-landscape-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-stone-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                Kapadokya Hakkında
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Nevşehir iline bağlı Kapadokya, volkanik kayaların şekillendirdiği peri bacaları, yeraltı şehirleri ve şafakta balonlarla süslenen gökyüzüyle dünyanın en büyülü coğrafyalarından biridir. Aşağıda Kapadokya seyahati hakkında en sık sorulan soruları ve cevaplarını bulabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all duration-200 ${
                openIndex === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className={`font-semibold text-sm leading-snug pr-4 ${openIndex === i ? "text-amber-800" : "text-stone-900"}`}>
                  <a id={`sss-${i + 1}`} className="scroll-mt-20">{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-500 text-white rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Related Links */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Link to="/istanbul-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-building-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">İstanbul SSS</p>
            <p className="text-xs text-stone-400">Boğaz ve tarihi yarımada rehberi</p>
          </Link>
          <Link to="/antalya-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-sun-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Antalya SSS</p>
            <p className="text-xs text-stone-400">Akdeniz tatili için rehber</p>
          </Link>
          <Link to="/place/kapadokya" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-map-pin-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Kapadokya Detay</p>
            <p className="text-xs text-stone-400">Kapsamlı mekan rehberi</p>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default KapadokyaFaq;
